"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Toggle.less");

var _utils = require("../utils/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Toggle = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Toggle, _Component);

  var _super = _createSuper(Toggle);

  function Toggle(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Toggle);
    _this = _super.call(this, props);
    _this.state = {
      isOn: props.isOn,
      onLabel: props.onLabel,
      offLabel: props.offLabel
    };
    return _this;
  }

  (0, _createClass2.default)(Toggle, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$state = this.state,
          onLabel = _this$state.onLabel,
          offLabel = _this$state.offLabel,
          isOn = _this$state.isOn;

      if (nextProps.onLabel) {
        onLabel = nextProps.onLabel;
      }

      if (nextProps.offLabel) {
        offLabel = nextProps.offLabel;
      }

      if (nextProps.isOn != this.state.isOn) {
        isOn = nextProps.isOn;
      }

      this.setState({
        onLabel: onLabel,
        offLabel: offLabel,
        isOn: isOn
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (typeof this.props.onHandleBlur === 'function') {
        this.props.onHandleBlur();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var isOn = !this.state.isOn;
      this.setState({
        isOn: isOn
      });

      if (typeof this.props.onHandleChange === 'function') {
        this.props.onHandleChange(isOn);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (typeof this.props.onHandleFocus === 'function') {
        this.props.onHandleFocus();
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (e.which === 32) {
        // 32=space
        e.preventDefault();
        this.setState({
          isOn: !this.state.isOn
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var id = (0, _utils.generateUUID)();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ui-toggle-wrapper ".concat(this.props.labelClass)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ui-toggle-label"
      }, this.props.label), /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: this.props.tabIndex,
        onKeyPress: function onKeyPress(e) {
          return _this2.handleKeyPress(e);
        },
        className: "ui-toggle ".concat(this.props.className)
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        name: "ui-toggle",
        className: "ui-toggle-checkbox",
        id: id,
        checked: this.state.isOn,
        onBlur: function onBlur() {
          _this2.handleBlur();
        },
        onChange: function onChange() {
          _this2.handleChange();
        },
        onFocus: function onFocus() {
          _this2.handleFocus();
        }
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "ui-toggle-label ",
        htmlFor: id
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-toggle-inner",
        "data-content-on": this.props.onLabel,
        "data-content-off": this.props.offLabel
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "ui-toggle-switch"
      }))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        isOn: _propTypes.default.bool,
        onLabel: _propTypes.default.string,
        offLabel: _propTypes.default.string,
        onHandleChange: _propTypes.default.func,
        onHandleFocus: _propTypes.default.func,
        onHandleBlur: _propTypes.default.func,
        tabIndex: _propTypes.default.number
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        isOn: false,
        onLabel: 'ON',
        offLabel: 'OFF',
        tabIndex: 0
      };
    }
  }]);
  return Toggle;
}(_react.Component);

exports.default = Toggle;